import {
  Datagrid,
  DeleteWithConfirmButton,
  EditButton,
  Create as RACreate,
  Edit as RAEdit,
  Filter as RAFilter,
  List as RAList,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';
import TranslateInput, { transform } from '../../common/TranslationInput';

import CustomPagination from '../../CustomPagination';
import { useTranslate } from '../../locales';

export const Create = (props: any) => (
  <RACreate
    {...props}
    mutationMode="pessimistic"
    redirect="list"
    transform={(data) => transform(data)}>
    <SimpleForm>
      <TranslateInput {...props} />
    </SimpleForm>
  </RACreate>
);

export const Edit = (props: any) => (
  <RAEdit
    {...props}
    mutationMode="pessimistic"
    transform={(data) => transform(data)}>
    <SimpleForm>
      <TranslateInput {...props} />
    </SimpleForm>
  </RAEdit>
);

export const Filter = (props: any) => {
  const translate = useTranslate();
  return (
    <RAFilter {...props}>
      <TextInput label={translate('admin.search')} source="q" alwaysOn />
    </RAFilter>
  )
}

export const List = (props: any) => {
  const translate = useTranslate();
  return (
    <RAList
      {...props}
      filters={<Filter />}
      filter={{
        deletedAt: { equals: null },
      }}
      undoable="false"
      perPage={50}
      pagination={<CustomPagination />}>
      <Datagrid>
        <TextField source="name" label={translate('admin.name')} />
        <EditButton />
        <DeleteWithConfirmButton mutationMode="pessimistic" />
      </Datagrid>
    </RAList>
  );
};
